import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { trackRedditPageVisit, isPublicPage } from '../lib/redditPixel'

/**
 * Hook to track Reddit Pixel page visits on public pages
 * Automatically tracks PageVisit when route changes on public pages
 */
export const useRedditPixel = () => {
  const location = useLocation()

  useEffect(() => {
    // Only track on public pages
    if (isPublicPage(location.pathname)) {
      // Small delay to ensure Reddit Pixel is loaded
      const timer = setTimeout(() => {
        trackRedditPageVisit(location.pathname)
      }, 100)

      return () => clearTimeout(timer)
    }
  }, [location.pathname])
}

